<template>
  <!--surround the select box with a "custom-select" DIV element. Remember to set the width:-->
  <div>
    <div class="custom-select-box-base" :id="id">
      <select>
        <option value selected>Select <slot></slot>...</option>
        <option v-for="item in items" :key="item.id" :value="item[0]">
          {{ item[1] }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    id: String,
    set: String,
  },
  computed: {},

  updated() {
    var t = this;
    var x, j, selElmnt, b, c;
    x = document.getElementById(this.id);
    selElmnt = x.getElementsByTagName("select")[0];

    /*for each element, create a new DIV that will contain the option list:*/
    b = document.getElementById(this.id + "elementFullList");
    b.innerHTML = "";
    for (j = 1; j < selElmnt.length; j++) {
      /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.id = c.innerHTML.split(" ").join("-") + "_element";
      c.setAttribute("data-value", selElmnt.options[j].value);
      c.addEventListener("click", function () {
        t.$emit(
          "onSelect_" + t.id,
          this.innerHTML,
          this.getAttribute("data-value")
        );
        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
  },
  mounted() {
    var t = this;
    var x, j, selElmnt, a, b, c;
    /*look for any elements with the class "custom-select":*/
    x = document.getElementById(this.id);

    selElmnt = x.getElementsByTagName("select")[0];
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.id = this.id + "elementSelected";
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x.appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    b.id = this.id + "elementFullList";
    for (j = 1; j < selElmnt.length; j++) {
      /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.id = c.innerHTML.split(" ").join("-") + "_element";
      c.setAttribute("data-value", selElmnt.options[j].value);
      c.addEventListener("click", function () {
        t.$emit(
          "onSelect_" + t.id,
          this.innerHTML,
          this.getAttribute("data-value")
        );
        /*when an item is clicked, update the original select box,
        and the selected item:*/

        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x.appendChild(b);
    a.addEventListener("click", function (e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      e.stopPropagation();
      //closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });

    /*if the user clicks anywhere outside the select box,
then close all select boxes:*/
    //document.addEventListener("click", closeAllSelect);
  },
};
</script>

<style>
/* The container must be positioned relative: */
.custom-select-box-base {
  position: relative;
  color: #ffffff;
  font-size: 14px;
  font-family: "Open Sans";
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 0;

  height: 46px;
}

.custom-select-box-base select {
  display: none; /*hide original SELECT element: */
}

.select-selected {
  background-color: #1f2348;
}

/* Style the arrow inside the select element: */
.select-selected:after {
  position: absolute;
  content: "";
  top: 14px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #fff transparent transparent transparent;
}

/* Point the arrow upwards when the select box is open (active): */
.select-selected.select-arrow-active:after {
  border-color: transparent transparent #fff transparent;
  top: 7px;
}

/* style the items (options), including the selected item: */
.select-items div,
.select-selected {
  color: #ffffff;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
  cursor: pointer;
}

/* Style items (options): */
.select-items {
  position: absolute;
  background-color: #1f2348;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
  max-height: 200px;
  overflow: auto;
}

/* Hide the items when the select box is closed: */
.select-hide {
  display: none;
}

.select-items div:hover,
.same-as-selected {
  background-color: #282c5a;
}
</style>
